"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('@angular/common/http');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var operators_1 = require("rxjs/operators");
var core_api_shared_service_1 = require("../core-api-shared.service");
var core_api_client_config_1 = require("../../core-api-client.config");
var ProductTermService = /** @class */ (function () {
    /**
     * Initialises a new instance of the ProductTermService /> class.
     * @param http
     * @param config
     */
    function ProductTermService(http, config) {
        this.http = http;
        this.config = config;
    }
    /**
     * Get Related.
     * @param productTermId
     * @returns An Observable containing boolean
     */
    ProductTermService.prototype.GetRelated = function (productTermId) {
        return this.http.get(this.config.CoreApiURL + "/api/productterm/" + productTermId + "/related")
            .pipe(operators_1.catchError(core_api_shared_service_1.CoreApiSharedService.handleError()));
    };
    /**
     * Get List.
     * @param contractualAllocationId
     * @returns An Observable containing boolean
     */
    ProductTermService.prototype.GetList = function (contractualAllocationId) {
        var params = new http_1.HttpParams();
        if (contractualAllocationId)
            params = params.set('contractualAllocationId', contractualAllocationId.toString());
        return this.http.get(this.config.CoreApiURL + "/api/productterm/")
            .pipe(operators_1.catchError(core_api_shared_service_1.CoreApiSharedService.handleError()));
    };
    /**
     * Get.
     * @param id
     * @returns An Observable containing the ProductTerm>
     */
    ProductTermService.prototype.Get = function (id) {
        return this.http.get(this.config.CoreApiURL + "/api/productterm/" + id)
            .pipe(operators_1.catchError(core_api_shared_service_1.CoreApiSharedService.handleError()));
    };
    ProductTermService = __decorate([ __param(1, core_1.Inject(core_api_client_config_1.CORE_API_CLIENT_CONFIG)),
        __metadata("design:paramtypes", [http_1.HttpClient, Object])
    ], ProductTermService);
ProductTermService.ɵfac = function ProductTermService_Factory(t) { return new (t || ProductTermService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(core_api_client_config_1.CORE_API_CLIENT_CONFIG)); };
ProductTermService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ProductTermService, factory: function (t) { return ProductTermService.ɵfac(t); } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProductTermService, [{
        type: core_1.Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: Object, decorators: [{
                type: core_1.Inject,
                args: [core_api_client_config_1.CORE_API_CLIENT_CONFIG]
            }] }]; }, null); })();
    return ProductTermService;
}());
exports.ProductTermService = ProductTermService;

